import React from "react";
import { Box } from "@mui/material";

/**
 * DataGrid の description / measuringMethod / evaluationStandard などの
 * テキストカラムで改行を表示するための renderCell ヘルパー
 */
export const wrapTextCell = (params) => (
  <Box sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word", py: 0.5, lineHeight: 1.6 }}>
    {params.value || ""}
  </Box>
);
